import { render, staticRenderFns } from "./proof-view-new-annotations.vue?vue&type=template&id=3177b45f&scoped=true&"
import script from "./proof-view-new-annotations.vue?vue&type=script&lang=js&"
export * from "./proof-view-new-annotations.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-new-annotations.vue?vue&type=style&index=0&id=3177b45f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177b45f",
  null
  
)

export default component.exports